<template>
    <div>
        <div v-if="loading" class="loading"></div>
        <div v-if="errors" v-for="error in errors">
            <div class="div" v-if="Array.isArray(error)">
                <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-else>{{ error}}</div>
        </div>

        <button class="btn btn-danger" @click="goBack">Назад</button>

        <b-form @submit="onSubmit">

            <b-form-group
                id="input-manager"
                label="Менеджер"
                label-for="manager"
            >

                <b-form-input
                        id="name"
                        v-model="item.manager"
                        type="text"
                        placeholder="Менеджер"
                        disabled
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="select-role"
                label="Роль"
                label-for="role"
            >
                <b-form-select v-model="item.role">
                    <b-form-select-option id="role" :key="index" :value="role.name" v-for="(role, index) in roles" >{{ role.name_ru }}</b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group
                    id="input-name"
                    label="ФИО"
                    label-for="name"
                    description=""
            >
                <b-form-input
                        id="name"
                        v-model="item.name"
                        type="text"
                        placeholder="ФИО"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="input-company"
                label="Наименование компании"
                label-for="company"
                description=""
            >
                <b-form-input
                    id="company"
                    v-model="item.company"
                    type="text"
                    placeholder="Наименование компании"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="input-bin"
                label="БИН"
                label-for="bin"
                description=""
            >
                <b-form-input
                    id="bin"
                    v-model="item.bin"
                    type="text"
                    placeholder="БИН"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-legal-address"
                    label="Юридический адрес:"
                    label-for="legal-address"
                    description=""
            >
                <b-form-input
                        id="legal-address"
                        v-model="item.legal_address"
                        type="text"
                        placeholder="Юридический адрес"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-iik"
                    label="ИИК"
                    label-for="iik"
                    description=""
            >
                <b-form-input
                        id="iik"
                        v-model="item.iik"
                        type="text"
                        placeholder="ИИК"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-bik"
                    label="БИК"
                    label-for="bik"
                    description=""
            >
                <b-form-input
                        id="bik"
                        v-model="item.bik"
                        type="text"
                        placeholder="БИК"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-bank"
                    label="Наименование банка"
                    label-for="bank"
                    description=""
            >
                <b-form-input
                        id="bank"
                        v-model="item.bank_name"
                        type="text"
                        placeholder="Наименование банка"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-phone"
                    label="Телефон"
                    label-for="phone"
                    description=""
            >
                <b-form-input
                        id="phone"
                        v-model="item.phone"
                        type="text"
                        placeholder="Телефон"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-email"
                    label="E-mail"
                    label-for="email"
            >
                <b-form-input
                        id="email"
                        v-model="item.email"
                        type="email"
                        placeholder="E-mail"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="input-comment"
                    label="Комментарий"
                    label-for="comment"
            >
                <b-form-input
                        id="comment"
                        v-model="item.comment"
                        type="email"
                        placeholder="Комментарий"
                        disabled
                ></b-form-input>
            </b-form-group>

            <div class="buttons">
                <b-button type="submit">Обновить</b-button>
            </div>
        </b-form>

        <manager-histories
            :user_id="this.$route.params.id"
        >

        </manager-histories>
    </div>
</template>

<script>
    import managerHistories from '../histories/Index'
    export default {
        data() {
            return {
                item: {},
                managers: {},
                roles: {},
                errors: [],
                loading: false
            }
        },

        mounted() {
            this.loading = true

            this.axios
                .get(this.axios.defaults.baseURL + 'manager/managers')
                .then(response => {
                    this.managers = response.data.managers;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
            })

            if (this.$route.params.id) {
                this.axios
                    .get(this.axios.defaults.baseURL + 'manager/users/' + this.$route.params.id)
                    .then(response => {
                        this.item = response.data.user

                        for(let i = 0; i < this.managers.length; i++) {
                            if(this.managers[i].id == this.item.manager_id) {
                                this.item.manager = this.managers[i].name
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                    this.loading = false
                })
            }

            this.axios
                .get(this.axios.defaults.baseURL + 'manager/roles')
                .then(response => {
                    this.roles = response.data.roles;
                    console.log(this.roles)
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
            })
        },

        methods: {
            checkForm:function(e) {
                e.preventDefault();
                this.errors = [];
                if(!this.item.name) this.errors.push("ФИО обязателен.");
                if(!this.item.company) this.errors.push("Компания обязателен.");
                if(!this.item.bin) this.errors.push("БИН обязателен.");
                if(!this.item.email) this.errors.push("Email обязателен.");
                if(!this.item.phone) this.errors.push("Номер обязателен.");
                if (!this.item.bik) this.errors.push("БИК обязателен.");
                if (!this.item.iik) this.errors.push("ИИК обязателен.");
                if (!this.item.bank_name) this.errors.push("Наименование банка обязателен.");
                if (!this.item.legal_address) this.errors.push("Юридический адрес обязателен.");
            },

            onSubmit(e){
                this.checkForm(e)
                if (this.errors.length === 0){
                    this.axios
                        .put(this.axios.defaults.baseURL + 'manager/users/' + this.$route.params.id, this.item)
                        .then(response => {
                            console.log(response.data.message)
                            if (response.data.message === 'success') {
                                this.$router.push({name: 'ManagerUsers', params: {message: 'Пользователь успешно обновлен'}})
                            }else {
                                this.errors = response.data.errors
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            },

            goBack() {
                window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
            }
        },

        components:{
            'manager-histories': managerHistories
        }
    }
</script>

<style scoped lang="scss">
    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/manager/users/insert.vue